import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';
import { SkeletonCard, SkeletonListRow } from '../common';

const ROWS_COUNT = 9;

const LEFT_BLOCK = (
  <div className="flex flex-col gap-[8px] w-[133px]">
    <SkeletonBlock className="h-[16px] w-full rounded-[24px]" variant="sunked" />
    <SkeletonBlock className="h-[8px] w-[93px] rounded-[24px]" variant="sunked" />
  </div>
);

const RIGHT_BLOCK = (
  <SkeletonBlock className="h-[32px] w-[59px] shrink-0 rounded-[16px]" variant="sunked" />
);

export function PlayersList() {
  return (
    <SkeletonCard className="h-[462px] gap-[24px]">
      {Array.from({ length: ROWS_COUNT }).map((_, i) => (
        <SkeletonListRow key={i} leftBlock={LEFT_BLOCK} rightBlock={RIGHT_BLOCK} />
      ))}
    </SkeletonCard>
  );
}
